"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Username = function Username(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M12.003 17.634a5.592 5.592 0 002.632-.654.625.625 0 01.609 1.092 6.878 6.878 0 113.632-6.065c0 1.9-1.12 3.44-2.5 3.44a2.497 2.497 0 01-2.175-1.273 3.166 3.166 0 01-2.667 1.585c-1.811 0-3.28-1.68-3.28-3.752 0-2.071 1.468-3.75 3.28-3.75.91.011 1.767.424 2.343 1.127v-.157a.648.648 0 01.52-.65.625.625 0 01.73.617v3.751a1.25 1.25 0 001.25 1.25c.69 0 1.249-.979 1.249-2.188a5.624 5.624 0 10-5.623 5.627zm-.313-8.128c-1.208 0-2.187 1.12-2.187 2.501 0 1.382.98 2.501 2.187 2.501 1.208 0 2.187-1.12 2.187-2.5 0-1.382-.979-2.501-2.187-2.501z"
  }));
};

var _default = (0, _react.forwardRef)(Username);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Username, "Username", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Username.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Username.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9Vc2VybmFtZS50c3giXSwibmFtZXMiOlsiVXNlcm5hbWUiLCJwcm9wcyIsInJlZiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUFBOzs7Ozs7Ozs7Ozs7O0FBRUEsSUFBTUEsUUFBd0UsR0FBRyxTQUEzRUEsUUFBMkUsQ0FBQ0MsS0FBRCxFQUFRQyxHQUFSO0FBQUEsU0FDL0U7QUFBSyxJQUFBLEtBQUssRUFBRSxFQUFaO0FBQWdCLElBQUEsTUFBTSxFQUFFLEVBQXhCO0FBQTRCLElBQUEsT0FBTyxFQUFDO0FBQXBDLEtBQW9ERCxLQUFwRDtBQUEyRCxJQUFBLEdBQUcsRUFBRUM7QUFBaEUsTUFDRTtBQUNFLElBQUEsSUFBSSxFQUFDLGNBRFA7QUFFRSxJQUFBLENBQUMsRUFBQztBQUZKLElBREYsQ0FEK0U7QUFBQSxDQUFqRjs7ZUFTZSx1QkFBV0YsUUFBWCxDOzs7Ozs7Ozs7Ozs7OzBCQVRUQSxRIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYsIFJlZkZvcndhcmRpbmdDb21wb25lbnQsIFNWR1Byb3BzIH0gZnJvbSAncmVhY3QnO1xuXG5jb25zdCBVc2VybmFtZTogUmVmRm9yd2FyZGluZ0NvbXBvbmVudDxTVkdTVkdFbGVtZW50LCBTVkdQcm9wczxTVkdTVkdFbGVtZW50Pj4gPSAocHJvcHMsIHJlZikgPT4gKFxuICA8c3ZnIHdpZHRoPXsyNH0gaGVpZ2h0PXsyNH0gdmlld0JveD1cIjAgMCAyNCAyNFwiIHsuLi5wcm9wc30gcmVmPXtyZWZ9PlxuICAgIDxwYXRoXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAgIGQ9XCJNMTIuMDAzIDE3LjYzNGE1LjU5MiA1LjU5MiAwIDAwMi42MzItLjY1NC42MjUuNjI1IDAgMDEuNjA5IDEuMDkyIDYuODc4IDYuODc4IDAgMTEzLjYzMi02LjA2NWMwIDEuOS0xLjEyIDMuNDQtMi41IDMuNDRhMi40OTcgMi40OTcgMCAwMS0yLjE3NS0xLjI3MyAzLjE2NiAzLjE2NiAwIDAxLTIuNjY3IDEuNTg1Yy0xLjgxMSAwLTMuMjgtMS42OC0zLjI4LTMuNzUyIDAtMi4wNzEgMS40NjgtMy43NSAzLjI4LTMuNzUuOTEuMDExIDEuNzY3LjQyNCAyLjM0MyAxLjEyN3YtLjE1N2EuNjQ4LjY0OCAwIDAxLjUyLS42NS42MjUuNjI1IDAgMDEuNzMuNjE3djMuNzUxYTEuMjUgMS4yNSAwIDAwMS4yNSAxLjI1Yy42OSAwIDEuMjQ5LS45NzkgMS4yNDktMi4xODhhNS42MjQgNS42MjQgMCAxMC01LjYyMyA1LjYyN3ptLS4zMTMtOC4xMjhjLTEuMjA4IDAtMi4xODcgMS4xMi0yLjE4NyAyLjUwMSAwIDEuMzgyLjk4IDIuNTAxIDIuMTg3IDIuNTAxIDEuMjA4IDAgMi4xODctMS4xMiAyLjE4Ny0yLjUgMC0xLjM4Mi0uOTc5LTIuNTAxLTIuMTg3LTIuNTAxelwiXG4gICAgLz5cbiAgPC9zdmc+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBmb3J3YXJkUmVmKFVzZXJuYW1lKTtcbiJdfQ==